export const SET_CAMERA_FRONT_GUIDE = 'teamly/settings/SET_CAMERA_FRONT_GUIDE';


// eslint-disable-next-line import/no-anonymous-default-export
export default (state = [{ openModal: false }], action: any) => {
  switch (action.type) {
    case SET_CAMERA_FRONT_GUIDE:
      const { openModal } = action;
      return {
        ...state,
        openModal,
      };
    default:
      return state;
  }
};

export const setCameraFrontGuide = (openModal: any) => ({
  type: SET_CAMERA_FRONT_GUIDE,
  openModal,
});
